<template>
  <div>
    <h3>New Event</h3>

    <vx-card no-shadow class="mt-8">
      <h2 class="mb-6">General</h2>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Event Type</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="horizontal-row">
            <vs-button
              v-for="venueTrainingType in venueTrainingTypes"
              :key="venueTrainingType.id"
              @click="selectedVenueTrainingType = venueTrainingType.id"
              :color="selectedVenueTrainingType == venueTrainingType.id ? 'success' : 'rgb(80, 80, 80)'"
              :type="selectedVenueTrainingType == venueTrainingType.id ? 'filled' : 'border'"
              icon-pack="feather"
              :icon="selectedVenueTrainingType == venueTrainingType.id ? 'icon-check' : ''"
              class="mr-3 selection-button"
              >{{ venueTrainingType.label }}</vs-button
            >
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="title" placeholder="Title..." />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <textarea
            class="vs-inputx vs-input--input normal"
            style="height: 200px; font-family: Arial; line-height: 1.5rem"
            spellcheck="false"
            v-model="description"
            placeholder="Description..."
          />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row">
        <div class="vx-col sm:w-1/5 w-full">
          <span>When</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display: flex">
          <div class="my-4">
            <small class="date-label">Start</small>
            <flat-pickr :config="configdateStartTimePicker" v-model="startDate" placeholder="Start..." style="display: flex" />
          </div>

          <div class="my-4" style="margin-left: 8px">
            <small class="date-label">End</small>
            <flat-pickr :config="configdateEndTimePicker" v-model="endDate" placeholder="End..." style="display: flex" />
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Instructor</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <TypeAhead
            v-model="data"
            classes="typeahead-container"
            :placeholder="placeholder"
            src=""
            :getResponse="getResponse"
            :selectFirst="selectFirst"
            :limit="parseInt(limit)"
            :queryParamName="queryParamName"
            :minChars="parseInt(minChars)"
            :delayTime="parseInt(delayTime)"
            :onHit="onHit"
            :highlighting="highlighting"
            :render="render"
            :fetch="fetch"
          ></TypeAhead>

          <vs-chip v-if="instructorId !== null" color="success" class="mt-6 instructor-chip">
            {{ instructorDisplayName }}
          </vs-chip>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span><strong>Add general tag</strong></span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <tag-selector :multiple="false" placeholder="Click tag to add" v-on:tag="tagSelected" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span><strong>Add venue tag</strong></span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <venue-selector :multiple="false" placeholder="Click venue to add to tags" v-on:venue="venueSelected" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span><code>Selected tags</code></span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-chips placeholder="New Tag" v-model="tags" style="width: 100%">
            <vs-chip color="#24c1a0" :key="tag" @click="removeTag(tag)" v-for="tag in tags" closable>
              {{ tag }}
            </vs-chip>
          </vs-chips>
          <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
            Campus tag determines the skills users will aquire by completing this event. <br />
            Venue tag determines which venue it will be displayed as in the Campus report.
          </p>
        </div>
      </div>

      <vs-divider />

      <!-- IdamSegmentator section - Audience segmentation -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Segmentation (who can see)</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <IdamSegmentator v-model="userQuery" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Min Participants</span>
        </div>
        <div class="vx-col">
          <vs-input v-validate="'numeric'" name="minParticipants" v-model="minParticipants" placeholder="Min participants..." />
          <div class="text-danger text-sm" v-show="errors.has('minParticipants')">
            {{ errors.first("minParticipants") }}
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Max Participants</span>
        </div>
        <div class="vx-col">
          <vs-input v-validate="'numeric'" name="maxParticipants" v-model="maxParticipants" placeholder="Max participants..." />
          <div class="text-danger text-sm" v-show="errors.has('maxParticipants')">
            {{ errors.first("maxParticipants") }}
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Notification message</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="notificationMessage" placeholder="48 hours until {title} begins." />
          <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
            Notification will be sent to all participants exactly 2 days prior to the start date.
            <br />
            <span v-if="notificationMessage === ''" style="font-weight: 400"
              >Default message preview: "48 hours until {{ title }} begins."</span
            >
            <span v-if="notificationMessage !== ''" style="font-weight: 400">Message preview: "{{ notificationMessagePreview }}"</span>
          </p>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Survey link (optional)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input name="surveyLink" class="w-full" v-model="surveyLink" placeholder="Please enter survey link" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Survey description (optional)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="w-full"
            name="surveyDescription"
            v-model="surveyDescription"
            placeholder="Please enter survey description eg. 'Want to give feedback on this event? click the link below'"
          />
        </div>
      </div>
    </vx-card>

    <!-- Add Campus Button -->
    <div class="flex flex-wrap items-center justify-end mt-12">
      <vs-button @click="addVenueTraining" id="save-button" class="ml-auto mr-auto mt-2" size="large">Add Event</vs-button>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TypeAhead from "vue2-typeahead";
import VenueSelector from "@/components/Custom/VenueSelector.vue";
import TagSelector from "@/components/TagSelector.vue";
import IdamSegmentator from "@/components/Custom/IdamSegmentator/IdamSegmentator";

export default {
  components: {
    flatPickr,
    TypeAhead,
    VenueSelector,
    TagSelector,
    IdamSegmentator
  },
  data() {
    let ctx = this;

    return {
      configdateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        minDate: new Date(),
        dateFormat: "d-m-Y H:i",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateStartDate(selectedDates[0]);
        }
      },
      configdateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        minDate: new Date(),
        dateFormat: "d-m-Y H:i",
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateEndDate(selectedDates[0]);
        }
      },

      overrideStartHours: true,
      overrideEndHours: true,

      // Typeahead
      data: "",
      selectFirst: false,
      limit: 10,
      queryParamName: ":keyword",
      minChars: 2,
      delayTime: 500,
      placeholder: "Please enter Instructor name or email",
      classes: "typeahead",

      // Campus information
      venueId: "",
      venueName: "",
      title: "",
      description: "",
      startDate: null,
      surveyLink: "",
      surveyDescription: "",
      localStartDate: null,
      endDate: null,
      localEndDate: null,
      minParticipants: 1,
      maxParticipants: 100,
      notificationMessage: "",
      tags: [],
      instructorId: null,
      instructorDisplayName: null,

      selectedVenueTrainingType: 0,
      venueTrainingTypes: [
        {
          id: 0,
          label: "Regular Event"
        },
        {
          id: 1,
          label: "Masterclass"
        }
      ],

      userQuery: {
        userQueryEntries: []
      }
    };
  },
  computed: {
    notificationMessagePreview() {
      return this.notificationMessage.replace(/{title}/g, this.title);
    }
  },
  methods: {
    venueSelected(v) {
      //this.venueTrainingInstance.venueName = v.venueName;
      //this.venueTrainingInstance.venueId = v.venueId;
      if (v && v.venueTag) {
        if (!this.tags.includes(v.venueTag)) this.tags.push(v.venueTag);
      }

      //console.log("Selected tag", v.venueTag);
      //this.venueTrainingInstance.venue = v;
    },

    tagSelected(tag) {
      if (!this.tags.includes(tag)) this.tags.push(tag);
    },
    updateStartDate: function (date) {
      console.log("Update Start Date:", date);
      this.localStartDate = date;

      console.log(this.localStartDate);

      this.constrainDates();
    },
    updateEndDate: function (date) {
      console.log("Update End Date:", date);
      this.localEndDate = date;

      console.log(this.localEndDate);

      this.constrainDates();
    },
    constrainDates: function () {
      if (this.localStartDate !== null && this.localEndDate === null) {
        this.localEndDate = new Date(this.localStartDate);
        this.localEndDate.setHours(20);

        this.endDate = new Date(this.localEndDate);
      }

      if (this.localEndDate < this.localStartDate) {
        console.log("Constrain dates");

        this.localEndDate = new Date(this.localStartDate);
        this.endDate = new Date(this.localEndDate);
      }
    },

    removeTag(item) {
      this.tags.splice(this.tags.indexOf(item), 1);
    },

    getResponse: function (response) {
      return response.data;
    },
    onHit: function (item, vue /*, index*/) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      this.instructorId = selectedItem.userId;
      this.instructorDisplayName = item;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render: function (items /*, vue*/) {
      const titles = items.map(x => x.firstName + " " + x.lastName + " (" + x.email + ")");
      return titles;
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API + "/users?query=" + this.data);
    },

    addVenueTraining: function () {
      this.$vs.loading();

      const payload = {
        title: this.title,
        surveyLink: this.surveyLink,
        surveyDescription: this.surveyDescription,
        description: this.description,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        minParticipants: parseInt(this.minParticipants),
        maxParticipants: parseInt(this.maxParticipants),
        notificationMessage: this.notificationMessage,
        tags: this.tags,
        instructorId: this.instructorId,
        instructorDisplayName: this.instructorDisplayName,
        venueTrainingType: this.selectedVenueTrainingType,
        userQuery: this.userQuery
      };

      console.log("Saving payload:");
      console.log(payload);

      this.$http
        .post(process.env.VUE_APP_API + "/VenueTrainings", payload)
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Event added"
            });

            this.$router
              .push({
                name: "admin-venue-training",
                params: { venueTrainingId: resp.data.venueTrainingId }
              })
              .catch(() => {});
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not add Event: " + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  created() {}
};
</script>

<style lang="scss">
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
</style>